import React from "react";
import style from "./code.module.css";
import { checkCoupon, CheckCouponResult } from "../../services/firebase/checkCoupon";
import { CodeCheckResult } from "./code";
var CodeCheck = function CodeCheck(_ref) {
    var code = _ref.code, setCode = _ref.setCode, setCheckResult = _ref.setCheckResult, setCheckResponse = _ref.setCheckResponse;
    var doCheck = function doCheck() {
        if (!code || code.length <= 0)
            return;
        setCheckResult(CodeCheckResult.LOADING);
        checkCoupon(code).then(function (res) {
            setCheckResult(mapCodeCheckResult(res.result));
            if (res)
                setCheckResponse(res);
        }).catch(function () {
            return setCheckResult(CodeCheckResult.INVALID);
        });
    };
    var inputToUppercase = function inputToUppercase(e) {
        e.target.value = ("" + e.target.value).toUpperCase();
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "content-text"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "mb-8"
    }, "Pr\xFCfen Sie hier die G\xFCltigkeit und den Leistungsumfang Ihres Codes.", /*#__PURE__*/ React.createElement("br", null), "Im darauf folgenden Schritt k\xF6nnen Sie den Code dann einl\xF6sen."), /*#__PURE__*/ React.createElement("input", {
        type: "text",
        placeholder: "Code eingeben",
        onChange: function onChange(e) {
            return setCode(e.target.value.toUpperCase());
        },
        onInput: inputToUppercase,
        className: style.codeInput
    }), /*#__PURE__*/ React.createElement("button", {
        className: style.buttonOrange,
        onClick: function onClick() {
            return doCheck();
        }
    }, "CODE PR\xDCFEN"));
};
export default CodeCheck;
var mapCodeCheckResult = function mapCodeCheckResult(result) {
    switch (result) {
        case CheckCouponResult.VALID:
            return CodeCheckResult.VALID;
        case CheckCouponResult.ALREADY_USED:
            return CodeCheckResult.ALREADY_USED;
        case CheckCouponResult.INVALID:
        default:
            return CodeCheckResult.INVALID;
    }
};
